<template>
  <v-img :height="height" cover :src="bg_url" :class="cpnt_class">
    <div class="d-flex justify-center pt-5 mb-5" :id="id">
      <v-img
        alt="Botswana Services Logo"
        :class="'shrink mr-1 mobile-app-bar-logo ' + logo_class"
        contain
        :src="logo_url"
        transition="scale-transition"
        width="350"
      />
    </div>
  </v-img>
</template>

<script>
export default {
  name: "ContactPageBanner",
  props: {
    has_nav_bar: {
      type: Boolean,
      default: false,
    },
    bg_class: {
      type:String,
      default: ""
    },
    logo_class: {
      type: String,
      default: "logo-bg"
    },
    height:{
      type: [String,Number],
      default: "200px"
    },
    bg_url: {
      type: String,
      default: "https://botswanaservices.com/img/malls/bw/riverwalk.png",
    },
    logo_url: {
      type: String,
      default:
        "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1599568893/botswana%20services/website%20assets/logo_yyz06i.png",
    },
    id: {
      type: String,
      default: () => {
        return (
          "carded_section_header_" +
          Math.random() +
          "_" +
          (new Date()).getTime()
        );
      },
    }
  },
  computed:{
      cpnt_class(){
          var cls = ' ' + this.bg_class + ' ';
          if(this.has_nav_bar == true){
              cls = cls + " componet-has-nav-bar";
          }
          return cls;
      }
  }
};
</script>
